var isFirstClick = true;
const allCloseIcons = document.getElementsByClassName("d6-close-icon");
const allOpenIcons = document.getElementsByClassName("d6-open-icon");

  function toggleAccordion(index) {
    var contents = document.querySelectorAll('.accordion-content');

    // contents.forEach(function(content, i) {
    //   if (i === index) {
    //     content.style.display = isFirstClick ? 'block' : (content.style.display === 'none' ? 'block' : 'none');
    //   } else {
    //     content.style.display = 'none';
    //   }
    // });
    
    for (let i = 0; i < contents.length; i++) {
      if (i === index) {
        contents[i].style.display = isFirstClick ? 'block' : (contents[i].style.display === 'none' ? 'block' : 'none');
        allOpenIcons[i].style.display = isFirstClick ? 'block' : (allOpenIcons[i].style.display === 'none' ? 'block' : 'none');
        allCloseIcons[i].style.display = isFirstClick ? 'none' : (allCloseIcons[i].style.display === 'block' ? 'none' : 'block');
      } else {
        contents[i].style.display = "none";
        allOpenIcons[i].style.display = "none";
        allCloseIcons[i].style.display = "block";
      }
    }

    isFirstClick = false;
  }


allCloseIcons[0].style.display = "none";
allOpenIcons[0].style.display = "block";